// src/Components/Notifications/NotificationBadge.tsx

import React from 'react';
import styles from '../Styles/NotificationBadge.module.scss';

interface NotificationBadgeProps {
  count: number;
  maxDisplay?: number; // Default: 9 (shows "9+" if count > 9)
}

/**
 * Notification Badge Component
 * 
 * Displays a red badge with notification count
 * - Shows actual count if <= maxDisplay
 * - Shows "maxDisplay+" if count > maxDisplay
 * - Hides completely if count === 0
 * 
 * @param count - Number of unread notifications
 * @param maxDisplay - Maximum number to display before showing "+" (default: 9)
 */
const NotificationBadge: React.FC<NotificationBadgeProps> = ({ 
  count, 
  maxDisplay = 9 
}) => {
  // ✅ Don't render if no notifications
  if (count === 0) return null;

  // ✅ Display "9+" if count > maxDisplay
  const displayCount = count > maxDisplay ? `${maxDisplay}+` : count.toString();

  return (
    <span 
      className={styles.badge}
      aria-label={`${count} ახალი შეტყობინება`}
      role="status"
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;